// imports
import React from "react"
import Hero from "./Hero";
import Problem from "./Problem";
import Solution from "./Solution";
import Features from "./Features";
import Join from "./Join";
import Preview from "./Preview";
import Trustworthy from "./Trustworthy";
import BlogsPreview from './BlogsPreview'

// export
const Home = () => {
  return (
    <main>
      <Hero />
      <Problem />
      <Solution />
      <Features />
      <Join />
      <Preview />
      <Trustworthy />
      <BlogsPreview />
    </main>
  )
}

export default Home;